import { FileValidationResponse } from './file-validation-response';
import { FormFileModel } from './form-file-model';

export class FileProcessingResponse {
  validationResponse: FileValidationResponse;
  file: FormFileModel;
}
